module.exports = __webpack_public_path__ + "odinstatic/media/pricing.40d2e7bd.svg";